import React from "react"
import {
  IconButton,
  Dialog,
  DialogTitle,
  Slide,
  DialogContent,
  Paper,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const HistoryDialog = ({ handleClose, details, goToChat }) => {
  const { priceNegotiated, book } = details
  const { title, isBundle, grade, subject, priceOriginal, publisher, comment, isbn } = book

  return (
    <Dialog TransitionComponent={Transition} onClose={handleClose} open>
      <DialogTitle>
        {title}
        <IconButton sx={{ position: "absolute", right: "1vw", top: "1vh" }} onClick={handleClose}>
          <CloseIcon color="secondary" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          overflow: "auto",
        }}>
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {/* <TableRow>
                <TableCell align="left">{action ? "Ich habe gekauft" : "Ich habe verkauft"}</TableCell>
                <TableCell align="right" />
              </TableRow> */}
              <TableRow>
                <TableCell align="left">Titel</TableCell>
                <TableCell align="right">{title}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="left">Klasse</TableCell>
                <TableCell align="right">{grade}</TableCell>
              </TableRow>
              {!isBundle && (
                <>
                  <TableRow>
                    <TableCell align="left">Fach</TableCell>
                    <TableCell align="right">{subject}</TableCell>
                  </TableRow>
                  {/* eslint-disable-next-line */}
                  {!!isbn && isbn != 0 ? (
                    <TableRow>
                      <TableCell align="left">ISBN</TableCell>
                      <TableCell align="right">{isbn}</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {publisher ? (
                    <TableRow>
                      <TableCell align="left">Verlag</TableCell>
                      <TableCell align="right">{publisher}</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {priceOriginal ? (
                    <TableRow>
                      <TableCell align="left">Originalpreis</TableCell>
                      <TableCell align="right">{priceOriginal} €</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {priceNegotiated ? (
                    <TableRow>
                      <TableCell align="left">Verhandelter Preis</TableCell>
                      <TableCell align="right">{priceNegotiated} €</TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                </>
              )}
              {isBundle || comment ? (
                <TableRow>
                  <TableCell align="left">Information</TableCell>
                  <TableCell align="right">{isBundle ? `Alle Bücher der Klasse ${grade} zusammen.` : comment}</TableCell>
                </TableRow>
              ) : (
                <></>
              )}
              <TableRow onClick={() => goToChat()} sx={{ cursor: "pointer" }}>
                <TableCell align="left">Partner</TableCell>
                <TableCell align="right" sx={{ textDecoration: "underline" }}>
                  Chat
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Divider sx={{ mt: "3vh" }} />

        <Typography sx={{ mt: "1vh", color: "gray" }} variant="caption">
          Kein Anspruch auf Rückerstattung. <br /> Preis nach Absprache mit dem Partner.
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default HistoryDialog
